import { Building2, Tags, Users } from 'lucide-react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { LiksPage } from '../../components/liks/LiksPage/LiksPage';
import { LiksTabs } from '../../components/liks/LiksTabs/LiksTabs';
import { useI18n } from '../../i18n/useI18n';
import { TenantLabelsAndGroupsTab } from './tabs/TenantLabelsAndGroupsTab';
import { TenantTab } from './tabs/TenantTab';
import { TenantUsersTab } from './tabs/TenantUsersTab';
import './TenantManagementPage.css';
import {
  DEFAULT_TENANT_TAB,
  isTenantTabId,
  resolveTenantTabPath,
  type TenantTabId,
} from '../../routes/tenantPaths';

export function TenantManagementPage() {
  const { translate } = useI18n();
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();

  if (!isTenantTabId(tab)) {
    return <Navigate to={resolveTenantTabPath(DEFAULT_TENANT_TAB)} replace />;
  }

  const activeTabId: TenantTabId = tab;

  const handleTabChange = (nextTabId: string) => {
    if (!isTenantTabId(nextTabId)) {
      return;
    }
    navigate(resolveTenantTabPath(nextTabId));
  };

  const tabs = [
    {
      id: 'organisation',
      label: translate('organisationManagement.tabs.organisation'),
      icon: <Building2 strokeWidth={2} aria-hidden />,
      content: <TenantTab />,
    },
    {
      id: 'users',
      label: translate('organisationManagement.tabs.users'),
      icon: <Users strokeWidth={2} aria-hidden />,
      content: <TenantUsersTab />,
    },
    {
      id: 'labels-and-groups',
      label: translate('organisationManagement.tabs.labelsAndGroups'),
      icon: <Tags strokeWidth={2} aria-hidden />,
      content: <TenantLabelsAndGroupsTab />,
    },
  ];

  return (
    <LiksPage
      className="tenant-management-page"
      header={<h1>{translate('organisationManagement.title')}</h1>}
      content={
        <div className="tenant-management-page__content">
          <LiksTabs
            tabs={tabs}
            activeTabId={activeTabId}
            onActiveTabIdChange={handleTabChange}
            aria-label={translate('organisationManagement.tabs.legend')}
          />
        </div>
      }
    />
  );
}
